import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  state: {
    user: null,
    metadata: null
  },
  mutations: {
    UPDATE_USER(state, { user, metadata }) {
      if ( user ) state.user = user
      if ( metadata ) state.metadata = metadata
    },
  },
  actions: {},
  getters: {
    user: state => state.user,
    metadata: state => state.metadata
  },
}
